import { APPROVE_MISMATCH_REQUEST } from '../../endpoints';
import makeAuthenticatedRequest from '../base-api';

interface ApproveMismatchRequestResponse {
  success: boolean;
  message?: string;
}

interface ApproveMismatchRequestPayload {
  _id: string;
  startTime: string;
  stopTime: string;
  duration: number;
  logId: string;
  timeZone: string;
}

const approveMismatchRequest = async (
  payload: ApproveMismatchRequestPayload
): Promise<ApproveMismatchRequestResponse> => {
  try {
    const response = await makeAuthenticatedRequest(APPROVE_MISMATCH_REQUEST, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (!result.success) {
      throw new Error(result.message);
    }

    return result;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export {
  approveMismatchRequest,
  type ApproveMismatchRequestPayload,
  type ApproveMismatchRequestResponse,
};
